// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__0xfLE","spin":"styles_spin__Bn51z"};